import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Motion";
import { LANGUAGE_LINES, LANG_PHONE } from "../data/content";

export default function LanguageHelp() {
  return (
    <main id="main-content" className="min-h-screen pt-24" data-testid="language-help-page">
      <PageHero
        eyebrow="Language assistance"
        lines={["Free language help", <>is <span className="italic text-[#A9533A]">always</span> available.</>]}
        intro="You do not need to speak English to get services from Surgevity Solutions. We provide qualified interpreters and translated materials at no cost to you."
        testid="language-hero"
      />
      <section className="bg-[#FDFBF7] pb-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 lg:px-12">
          <Reveal>
            <p className="text-lg leading-relaxed text-[#1E2621]">
              Call <a href={`tel:${LANG_PHONE.replace(/\D/g, "")}`} className="font-semibold text-[#A9533A] underline underline-offset-4" data-testid="language-phone-link">{LANG_PHONE}</a> and tell us your language, or say the name of your language in it. We will connect a qualified interpreter — free of charge — for your calls, sessions and paperwork.
            </p>
          </Reveal>
          <Reveal className="mt-10 space-y-4" data-testid="language-list">
            {LANGUAGE_LINES.map(([lang, text, tail]) => (
              <p key={lang} dir={lang.includes("العربية") ? "rtl" : "ltr"} className="rounded-2xl border border-[#E2DCD0] bg-[#FAF8F4] p-5 text-base leading-relaxed text-[#1E2621]" data-testid={`language-line-${lang.split("/")[0].trim().toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <span className="font-mono-ui mr-2 text-xs uppercase tracking-[0.15em] text-[#A9533A]">{lang}:</span>
                {text} {LANG_PHONE} {tail}
              </p>
            ))}
          </Reveal>
          <Reveal>
            <p className="mt-8 text-sm leading-relaxed text-[#4A554D]">
              This notice is available in print and will be read to you over the phone in your language. If you need this notice in another language not listed here, ask us and we will provide it at no cost.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
